



































































































































































































































































































































































































































































































































































































import {
    Component,
    Vue
} from "vue-property-decorator";
import HomeFooter from "./HomeFooter.vue";
import HomeTop from "@/components/Top/HomeTop.vue";
import HomeNews from "@/components/HomeNews.vue";
import HomeTopics from "@/components/HomeTopics.vue";
import HomeBlockAdv from "@/components/HomeBlockAdv.vue";
import {
    api_get,
    api_post
} from "../api/isso";
@Component({
    components: {
        HomeFooter,
        HomeTop,
        HomeNews,
        HomeTopics,
        HomeBlockAdv,
    },
})
export default class Home extends Vue {
    loaded = true;
    forums = [];

    advs: any = [];

    top: any = [];

    news = [];
    slide = [];
    loading = false
    loading_topics = true
    loading_advs = true
    loading_users = true

    second_news_right = [{
            item_text: '成功转型?鄞州这个广场成培训机构天下',
            item_url: 'https://',
            hot: true
        },
        [{
                item_text: '我是测试',
                item_url: '',
                hot: false
            },
            {
                item_text: '我是测试',
                item_url: '',
                hot: false
            },
            {
                item_text: '我是测试',
                item_url: '',
                hot: false
            },
            {
                item_text: '我是测试',
                item_url: '',
                hot: false
            }, {
                item_text: '我是测试',
                item_url: '',
                hot: false
            }
        ],
        {
            item_text: '成功转型?鄞州这个广场成培训机构天下',
            item_url: 'https://',
            hot: true
        },
        [{
                item_text: '我是测试',
                item_url: '',
                hot: false
            },
            {
                item_text: '我是测试',
                item_url: '',
                hot: false
            },
            {
                item_text: '我是测试',
                item_url: '',
                hot: false
            }, {
                item_text: '我是测试',
                item_url: '',
                hot: false
            },
        ]
    ];

    third_news_left = [{
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '日本东京都下调疫情警戒级别',
        item_detail: "当地时间9月10日傍晚，日本东京都知事小池百合子举行临时记者会，表示将东京都的新冠疫情警戒级别由此前最高的“疫情正在扩大”下调1级至“必须警惕疫情再次扩大”。图为民众走过东京一家寿司店",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'http://n.sinaimg.cn/default/1_img/upload/3933d981/793/w930h663/20200910/8dee-iyywcsz2788892.jpg',
        item_site: "新浪",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }, {
        item_text: '鄞州这家商业广场，几乎成了培训广场，很繁荣~广场，很繁荣~广场，很繁荣~',
        item_detail: "加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年0真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。加州史上最大野火 2020真是多灾多难的一年。",
        item_url: 'https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38521630&Pink=False',
        item_pic: 'https://club.isso.com.cn/upload_2020/day_200911/c6e02b7990y05g11ec0e082608972a047bbba2698.jpg',
        item_site: "口水吧",
        item_site_url: "https:baidu.com",
        item_author: "联创团购",
        item_time: "09-11 14:19"
    }]
    top_users = [{
        "user_name": "紫菜饭团",
        "cs": 47,
        "user_id": 189
    }]

    hot_topics = [{
        forum_name: "口水吧",
        title: '鄞州这家商业广场，几乎成了培训广场，很繁荣~广场，很繁荣~广场，很繁荣~',
        topic_id: 38521630,
    }]

    block_ads = [{"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38179003&Pink=False",
            "note": "脑、笔记本、电脑配件等。电话：18967888808（微信同号）",
            "title": "优惠易索出售：二手台式电"
        }, {
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38221714&Pink=False",
            "note": "需要短或加微信13566546324 QQ：513704941",
            "title": "出个人闲用品"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38322950&Pink=False",
            "note": "全力 推荐客户 促进成交 规范线上线下交易",
            "title": "免费登记房源 大平台"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=36691278&Pink=False",
            "note": "大屏导航 360全景记录仪 氛围灯 电动尾门 手机控车 定速巡航",
            "title": "汽车原厂件增配"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=37683411&Pink=False",
            "note": "儒美工厂原木水性漆家具定制！工厂直销！欢迎大家考察！",
            "title": "儒美工厂原木水性漆家具"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38391180&Pink=False",
            "note": "回隅艺术，你专属的艺考直通车，联系人虞老师15336662389",
            "title": "回隅艺术，美术中考&高考"
        }, {"obj_url":'',
            "link_url": "http://club.isso.com.cn/Default.aspx?class=Topic&Topic=36683841&Pink=False",
            "note": "国产1.67以下，依视路全系列，全部立等可取，现场制作",
            "title": "加微信预约 19555775"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38505320&Pink=False",
            "note": "回收大叶329超市卡五粮液\\茅台\n批发月饼\\大闸蟹\\三门青蟹\\红酒",
            "title": "批【月饼】大闸蟹青蟹牛排"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38517400&Pink=False",
            "note": "5年老品牌的立刷POS，费率0.5%+3元（送了3个月的会员），之后",
            "title": "送点老品牌POS，0.5%+3，另"
        }, {"obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38516277&Pink=False",
            "note": "朝鲜开城黑参活动搞起来 又到下半年了  我又来了",
            "title": "中秋送礼除了月饼还有补品"
        }, {"obj_url":'',
            "link_url": "http://club.isso.com.cn/Default.aspx?class=Topic&Topic=36796906&Pink=False",
            "note": "想装修，找品阁,易索网友更有优惠折扣 微信15669219118",
            "title": "宁波本地装修公司，值得信"
        }, {
             "obj_url":'',
            "link_url": "https://club.isso.com.cn/Default.aspx?class=Topic&Topic=38391682&Pink=False",
            "note": "9月的350个新款全部到货，上新我们是认真的，支持宁波消费券",
            "title": "杜湖眼镜 9月新款到货喽"
        },
        {
            "obj_url": 'upload_image/Adv2/70465b6c-6163-44fd-aef1-4754a435a3b8.jpg'
        }
    ]

    src = "https://club.isso.com.cn/uploads/2020/09/09/z5y9pxvume7gxw2v.jpg"

    do_nav_click(f) {
        window.location.href =
            "https://club.isso.com.cn/Default.aspx?Class=Main&Forum=" + f.id;
    }

    do_nav_open_jin_baba() {
        window.location.href = "https://club.isso.com.cn/sjzx/";
    }

    mounted() {
        let that = this;
        this.block_ads = []
        this.top_users = []
        this.third_news_left = []
        this.second_news_right = []
        // api_post('/api/home/data/get').then(data =>{
        //   this.forums = data.forums
        //   this.advs = data.advs
        //   this.news =data.news
        //   this.topics = data.topics
        //   this.tops = data.tops
        //   this.block_advs = data.block_advs
        //   this.loaded = true
        // }).catch(msg=>{
        //   console.log(msg)
        // })
        api_get('/api/isso/index/get').then(data => {
            that.top = data.top
            that.second_news_right = data.right
            that.third_news_left = data.left
            that.slide = data.slide
            that.loading = true
        }).catch(msg => {
            console.error(msg)
        })

        api_get('/api/isso/index/hot/topic/get').then(data => {
            // console.log(data)
            that.hot_topics = data
            that.loading_topics = false
        }).catch(msg => {
            console.error(msg)
        })
        api_get('/api/isso/index/top/user/get').then(data => {
            // console.log(data)
            that.top_users = data
            that.loading_users = false
        }).catch(msg => {
            console.error(msg)
        })
        api_get('/api/isso/index/adv/get').then(data => {
            // console.log(data)
            this.loading_advs = false
            that.block_ads = data
            // that.loading_users  = false
        }).catch(msg => {
            console.error(msg)
        })

    }

    do_click_top_adv() {
        window.open(this.advs.home_top.url);
    }
    get_left_news_class(item) {
        return item.item_pic ? 'image-news' : ''
    }
    do_hot_click(topic) {
        window.open(`https://club.isso.com.cn/Default.aspx?class=Topic&Topic=${topic.topic_id}&Pink=False`)
    }

    do_open_slide(item) {
        window.open(item.item_url)
    }
    do_advs_click(item) {
        window.open(item.link_url)
    }
    get_adv_image(item){
        console.log(`http://club.isso.com.cn/${item.obj_url}`)
        return `http://club.isso.com.cn/${item.obj_url}`
    }
}
